import React, {PureComponent} from "react";
import styles from "./bottom-panel.module.css";
import {AnimationSettingsProp} from "../../../store/settings/types";
import {TweenLite, Animation} from "gsap";
import playSound from "../../sounds/playSound";

interface BottomPanelProps {
    readonly delay?: number;
    readonly space?: number;
    readonly caption?: JSX.Element | string;
}

export class BottomPanel extends PureComponent<BottomPanelProps & AnimationSettingsProp> {
    private readonly hostElement: React.RefObject<HTMLDivElement>;
    private activeTween?: Animation;

    constructor(props: BottomPanelProps & AnimationSettingsProp, context: any) {
        super(props, context);

        this.hostElement = React.createRef();
    }

    render() {
        const {caption, children} = this.props;

        const header = caption
            ? (
                <header className={styles.header}>
                    {caption}
                </header>
            )
            : undefined;

        return (
            <div className={styles.bottom_panel} ref={this.hostElement}>
                {header}
                <section className={styles.buttons}>
                    {children}
                </section>
            </div>
        );
    }


    componentDidMount(): void {
        const {caption, delay, animation} = this.props;

        if (!this.hostElement.current || !animation.enabled)
            return;

        this.activeTween = TweenLite.from(this.hostElement.current, 0.33, {
            y: caption ? 178 : 130,
            delay: delay || 0.6,
            onStart: this.swoosh.bind(this)
        })
    }

    componentWillUnmount(): void {
        this.activeTween && this.activeTween.kill();
    }

    private swoosh() {
        playSound("panel-swoosh", 0.2);
    }
}